import { View, Image, useWindowDimensions, ScrollView } from "react-native";
import RenderHTML from "react-native-render-html";
import { customStyles } from "../../theme/styles"
// import BackButton from require("../../assets/benefits.png")
import React from 'react'

const Benefits = (props:any) => {
    let data = props.data

    const { width } = useWindowDimensions()
  return (
    <View style={customStyles.htmlContainer}>
            <Image style={customStyles.infoImagesStyle} source={require("../../assets/benefits.png")} />

            <ScrollView style={{ flex: 1 }} showsVerticalScrollIndicator={false} contentInsetAdjustmentBehavior="always">
                <View style={customStyles.htmlContent}>
                    <RenderHTML contentWidth={width} source={{ html: data["key_benefits"] }} />
                </View>
            </ScrollView>
        </View>
  )
}

export default Benefits
